import BaseAPI from '../BaseAPI';

class Portrait extends BaseAPI {
  constructor(props) {
    super(props);

    this.baseUrl = `/list?country=${process.env.REACT_APP_COUNTRY?.toUpperCase()}`;
  }

  /**
   * sends the cinema rent inquiry
   * @returns {Promise<*|Error>}
   */
  fetchAll() {
    const url = `/portrait${this.baseUrl}`;

    return this.get({ url });
  }
}

export default Portrait;
